import { IProduct } from '../products';
import { NewDealerActionKeys as keys } from './newDealerActionKeys';
import * as types from './newDealerActionTypes';
import {
  IFetchNewDealerRequest,
  INewDealerRejection,
  INewDealerRequestCart,
  INewDealerRequestCompleteEvent,
  INewDealerRequestEvent,
  INewDealerRequestFull,
  INewDealerRequestMin,
  NewDealerRequestCartUpdate,
  NewDealerRequestCompleteEventRequest,
  NewDealerRequestEventRequest,
  NewDealerRequestUpdateRequest
} from './newDealerInterfaces';

export const newDealerActionCreators = {
  addCompleteEvent: (payload: NewDealerRequestCompleteEventRequest): types.AddNewDealerRequestCompleteEvent => ({
    payload,
    type: keys.ADD_NEW_DEALER_REQUEST_COMPLETE_EVENT
  }),
  addEvent: (payload: NewDealerRequestEventRequest): types.AddNewDealerRequestEvent => ({
    payload,
    type: keys.ADD_NEW_DEALER_REQUEST_EVENT
  }),
  advanceState: (newDealerRequestId: number): types.AdvanceNewDealerRequest => ({
    payload: { newDealerRequestId },
    type: keys.ADVANCE_NEW_DEALER_REQUEST
  }),
  completeRequest: (newDealerRequestId: number): types.CompleteNewDealerRequest => ({
    payload: { newDealerRequestId },
    type: keys.COMPLETE_NEW_DEALER_REQUEST
  }),
  createCustomer: (newDealerRequestId: number): types.CreateNewDealerCustomer => ({
    payload: { newDealerRequestId },
    type: keys.CREATE_NEW_DEALER_CUSTOMER
  }),
  deleteCart: (payload: { newDealerRequestId: number; brand: string }): types.DeleteNewDealerCart => ({
    payload,
    type: keys.DELETE_NEW_DEALER_CART
  }),
  deleteCompleteEvent: (payload: NewDealerRequestCompleteEventRequest): types.DeleteNewDealerRequestCompleteEvent => ({
    payload,
    type: keys.DELETE_NEW_DEALER_COMPLETE_REQUEST_EVENT
  }),
  deleteEvent: (payload: NewDealerRequestEventRequest): types.DeleteNewDealerRequestEvent => ({
    payload,
    type: keys.DELETE_NEW_DEALER_REQUEST_EVENT
  }),
  fetchRequest: (payload: IFetchNewDealerRequest): types.FetchNewDealerRequest => ({
    payload,
    type: keys.FETCH_NEW_DEALER_REQUEST
  }),
  fetchRequests: (): types.FetchNewDealerRequests => ({
    type: keys.FETCH_NEW_DEALER_REQUESTS
  }),
  importNewDealerOrders: (newDealerRequestId: number): types.ImportNewDealerOrders => ({
    payload: { newDealerRequestId },
    type: keys.IMPORT_NEW_DEALER_ORDERS
  }),
  reject: (payload: Pick<INewDealerRejection, 'newDealerRequestId' | 'reason'>): types.RejectNewDealerRequest => ({
    payload,
    type: keys.REJECT_NEW_DEALER_REQUEST
  }),
  removeCart: (payload: { newDealerRequestId: number; brand: string }): types.RemoveNewDealerCart => ({
    payload,
    type: keys.REMOVE_NEW_DEALER_CART
  }),
  removeCompleteEvent: (
    payload: Pick<INewDealerRequestCompleteEvent, 'newDealerRequestCompleteEventTypeId' | 'newDealerRequestId'>
  ): types.RemoveNewDealerRequestCompleteEvent => ({
    payload,
    type: keys.REMOVE_NEW_DEALER_COMPLETE_REQUEST_EVENT
  }),
  removeEvent: (newDealerRequestEventId: number): types.RemoveNewDealerRequestEvent => ({
    payload: { newDealerRequestEventId },
    type: keys.REMOVE_NEW_DEALER_REQUEST_EVENT
  }),
  searchCatalog: (payload: { cartId: number; searchTerm: string }): types.SearchNewDealerCatalog => ({
    payload,
    type: keys.SEARCH_NEW_DEALER_CATALOG
  }),
  setCompleteEvent: (payload: INewDealerRequestCompleteEvent): types.SetNewDealerRequestCompleteEvent => ({
    payload,
    type: keys.SET_NEW_DEALER_REQUEST_COMPLETE_EVENT
  }),
  setEvent: (payload: INewDealerRequestEvent): types.SetNewDealerRequestEvent => ({
    payload,
    type: keys.SET_NEW_DEALER_REQUEST_EVENT
  }),
  setProgram: (payload: INewDealerRequestCart): types.SetNewDealerProgram => ({
    payload,
    type: keys.SET_NEW_DEALER_PROGRAM
  }),
  setRequest: (payload: INewDealerRequestFull): types.SetNewDealerRequest => ({
    payload,
    type: keys.SET_NEW_DEALER_REQUEST
  }),
  setRequestMins: (payload: INewDealerRequestMin[]): types.SetNewDealerRequestMins => ({
    payload,
    type: keys.SET_NEW_DEALER_REQUEST_MINS
  }),
  setSearch: (payload: { cartId: number; searchTerm: string; products: IProduct[] }): types.SetNewDealerSearch => ({
    payload,
    type: keys.SET_NEW_DEALER_SEARCH
  }),
  toggleCatalogSearch: (): types.ToggleNewDealerCatalogSearch => ({ type: keys.TOGGLE_NEW_DEALER_CATALOG_SEARCH }),
  toggleEventSave: (payload: NewDealerRequestEventRequest): types.ToggleNewDealerEventSave => ({
    payload,
    type: keys.TOGGLE_NEW_DEALER_EVENT_SAVE
  }),
  updateCart: (payload: NewDealerRequestCartUpdate): types.UpdateNewDealerCart => ({
    payload,
    type: keys.UPDATE_NEW_DEALER_CART
  }),
  updateRequest: (payload: NewDealerRequestUpdateRequest): types.UpdateNewDealerRequest => ({
    payload,
    type: keys.UPDATE_NEW_DEALER_REQUEST
  }),
  validateNewDealerRequest: (newDealerRequestId: number): types.ValidateNewDealerRequest => ({
    payload: { newDealerRequestId },
    type: keys.VALIDATE_NEW_DEALER_REQUEST
  })
};
